import {
    PageContainerDPC,
} from '@dpc-fe/shared';
import {graphql} from 'gatsby';
import React,  {useEffect, useState} from 'react';
import moment from "moment";
import 'moment/locale/it';
import {getSlug, prop} from "../functions/functions";
import LogoSVG from "@dpc-fe/shared/img/dpc.logo.sprite.svg";
import { Splide,SplideTrack, SplideSlide } from '@splidejs/react-splide';

export default ({data}) => {

    const language = 'it';
    const galleriaVideo = data.node?.relationships?.field_video_carousel;
    const avvisiItAlert = data.node?.relationships?.field_avvisi_it_alert;
    const testoPresentazione = () => {
        if(data.node?.field_choose_link_testo_presenta && data.node?.relationships?.field_link_int_testo_presenta) {
            return (<h2><a href={'/' + language + data.node?.relationships?.field_link_int_testo_presenta.fields.slug} dangerouslySetInnerHTML={{ __html: data.node?.field_testo_presentazione.replace(/\n/g, "<br/>")}}></a></h2>)
        } else if (!data.node?.field_choose_link_testo_presenta && data.node?.field_link_ext_testo_presenta) {
            return (<h2><a href={data.node?.field_link_ext_testo_presenta.uri} dangerouslySetInnerHTML={{ __html: data.node?.field_testo_presentazione.replace(/\n/g, "<br/>")}}></a></h2>)
        } else return  (<h2>{data.node?.field_testo_presentazione}</h2>)
    }
    const azionePresentazione = () => {
        if(data.node?.field_choose_link_act_presenta  && data.node?.relationships?.field_link_int_act_presenta ) {
            return (<h3><a href={'/' + language + data.node?.relationships?.field_link_int_act_presenta.fields.slug}>{data.node?.field_azione_presentazione}</a></h3>)
        } else if (!data.node?.field_choose_link_act_presenta  && data.node?.field_link_ext_act_presenta ) {
            return (<h3><a href={data.node?.field_link_ext_act_presenta.uri}>{data.node?.field_azione_presentazione}</a></h3>)
        }
    }
    moment.locale('it')



    return (
        <PageContainerDPC
            menuItems={data.menu.edges}
            pageId={data.node?.drupal_internal__nid}
            title={data.node?.title}
            env={process.env.ENV}
            lang={language}
            domain={process.env.MINISITO_IT_ALERT_LABEL}
            //subdomainMenuItems={data.menuMinisito.edges}
            basePathNavbar={process.env.MINISITO_IT_ALERT_URL}
            minisiti={prop}
            immagineShare={data.node?.relationships?.field_immagine_dettaglio ? process.env.MINISITO_IT_ALERT_URL + data.node.relationships?.field_immagine_dettaglio?.relationships?.image?.localFile?.publicURL: process.env.MINISITO_IT_ALERT_URL + data.socialImg?.relationships?.image?.localFile?.publicURL}
            abstractShare={data.node?.body?.processed ? data.node.body.processed.replace(/<\/?[^>]+(>|$)/g, "") : ''}
            slug={process.env.MINISITO_IT_ALERT_URL + '/' + language}
            menuFooterItems={data.menuFooter.edges}
            isItAlert={true}
            isHomepage={true}
        >

            <section className="homepage-section section-presentazione"
                     style={{"background-image": `url(${data.node?.relationships?.field_sfondo_presentazione?.relationships?.field_immagine?.localFile?.publicURL})`}}>
                <div className="container">
                    <div className="px-custom">
                        <div className="row">
                            <div className="col-12">
                                <div className="logo">
                                    <svg className="icon it-alert-logo-colore">
                                        <use xlinkHref={`${LogoSVG}#dpc.it-alert.logo-colore`}/>
                                    </svg>
                                </div>
                                <h1>{data.node?.field_titolo_presentazione}</h1>
                                {testoPresentazione()}
                                {azionePresentazione()}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="homepage-section section-info">
                <div className="container">
                    <div className="px-custom">
                        <div className="row">
                            {data.node?.field_titolo_sezione_avvisi &&
                                <div className="col-12">
                                    <h2>{data.node?.field_titolo_sezione_avvisi}</h2>
                                </div>
                            }
                            <div className="col-12">
                                <div className="row">
                                    {(Array.isArray(avvisiItAlert) && avvisiItAlert.length > 0) &&
                                        avvisiItAlert.map( avviso =>
                                            <div className="col-12 col-md-4">
                                                <h3>{avviso.field_titolo}</h3>
                                                <img src={avviso.relationships?.field_immagine?.relationships?.field_immagine?.localFile?.publicURL} alt=""/>
                                                <div dangerouslySetInnerHTML={{__html: (avviso.field_didascalia ? avviso.field_didascalia.processed : '')}}/>
                                            </div>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {data.node?.field_titolo_sezione_video && (Array.isArray(galleriaVideo) && galleriaVideo.length > 0) &&
                <section className="homepage-section section-video">
                    <div className="container">
                        <div className="px-custom">
                            <div className="row">
                                {data.node?.field_titolo_sezione_video &&
                                    <div className="col-12">
                                        <h2>{data.node?.field_titolo_sezione_video}</h2>
                                    </div>
                                }
                                <div className="col-12">

                                    <Splide className='carousel-wrapper' hasTrack = {false} aria-label="It Alert video"
                                            options={{
                                                type: 'loop',
                                                rewind: true,
                                                perPage: 3,
                                                drag: true,
                                                perMove: 1,
                                                focus: 'center',
                                                arrows: false,
                                                easing: 'linear',
                                                gap: '15px',
                                                breakpoints: {
                                                    640: {
                                                        perPage: 1,
                                                        perMove: 1
                                                    },
                                                    992: {
                                                        perPage: 3,
                                                        perMove: 1
                                                    },
                                                }
                                            }}>
                                        <SplideTrack className='carousel-video'>
                                            {(Array.isArray(galleriaVideo) && galleriaVideo.length > 0) &&
                                                galleriaVideo.map( video =>
                                                    <SplideSlide className="video-thumbnail">
                                                        <a href={getSlug('/' + language + video.fields?.slug, process.env.MINISITO_IT_ALERT, video.relationships.field_sottodominio.name)}>
                                                            <img src={video.relationships?.field_immagine_dettaglio?.relationships?.field_immagine?.localFile?.publicURL}
                                                                 alt={video.relationships?.field_immagine_dettaglio?.field_alt}/>
                                                            <h3>{video.title}</h3>
                                                        </a>
                                                        
                                                    </SplideSlide>
                                                )}
                                        </SplideTrack>
                                    </Splide>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            }

            <section className="homepage-section section-iononrischio"
                     style={{"background-image": `url(${data.node?.relationships?.field_sfondo_sezione_notifiche?.relationships?.field_immagine?.localFile?.publicURL})`}}>
                <div className="container">
                    <div className="px-custom">
                        <div className="row">
                            <div className="col-12">
                                <h2>{data.node?.field_titolo_sezione_notifiche}</h2>
                                <p>{data.node?.field_testo_sezione_notifiche}</p>
                                <div className="it-btn-container">
                                    <a className="btn btn-xl btn-warning" href={data.node?.field_link_sezione_notifiche?.uri}
                                       target="_blank">{data.node?.field_link_sezione_notifiche?.title}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </PageContainerDPC>
    );
    //return (<>Homepage</>);
};

export const query = graphql`
{
  node: nodeHomepageMinisitoItAlert (field_codice_lingua: {eq: false}){
      relationships {
        field_link_int_testo_presenta {
          ...pubblicazioneFragment
        ...notiziaFragment
        ...approfondimentoFragment
        ...normativaFragment
        ...pageFragment
        ...bandoDiGaraFragment
        ...comunicatoStampaFragment
        ...corsoFragment
        ...mappaFragment
        ...timelineFragment
        ...sezioneConAnticipazioniFragment
        ...sezioneSenzaAnticipazioniFragment
        ...elencoApprofondimentiFragment
        ...elencoGlossariFragment
        ...elencoAttualitaFragment
        ...elencoPodcastFragment
        ...elencoPubblicazioniFragment
        ...elencoNormativaFragment
        ...elencoBandiEContrattiFragment
        ...elencoFotoVideoFragment
        ...homepageVolontariatoFragment
        ...homepageRelazioniFragment
        ...homepageRischiFragment
        ...homepageNazionaleFragment
        ...homepageMappeFragment
        ...homepageGiovaniFragment
        ...homepageFormazioneFragment
        ...homepageEventiFragment
        ...homepageEmergenzeFragment
        ...homepageDocsFragment
        ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
        ...bollettinoCriticitaFragment
        ...bollettinoVigilanzaFragment
        ...sezioneAllertaMeteoIdroFragment
        ...galleriaFotoFragment
        ...videoFragment
        ...galleriaFlickrFragment
        }
        field_link_int_act_presenta {
          ...pubblicazioneFragment
        ...notiziaFragment
        ...approfondimentoFragment
        ...normativaFragment
        ...pageFragment
        ...bandoDiGaraFragment
        ...comunicatoStampaFragment
        ...corsoFragment
        ...mappaFragment
        ...timelineFragment
        ...sezioneConAnticipazioniFragment
        ...sezioneSenzaAnticipazioniFragment
        ...elencoApprofondimentiFragment
        ...elencoGlossariFragment
        ...elencoAttualitaFragment
        ...elencoPodcastFragment
        ...elencoPubblicazioniFragment
        ...elencoNormativaFragment
        ...elencoBandiEContrattiFragment
        ...elencoFotoVideoFragment
        ...homepageVolontariatoFragment
        ...homepageRelazioniFragment
        ...homepageRischiFragment
        ...homepageNazionaleFragment
        ...homepageMappeFragment
        ...homepageGiovaniFragment
        ...homepageFormazioneFragment
        ...homepageEventiFragment
        ...homepageEmergenzeFragment
        ...homepageDocsFragment
        ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
        ...bollettinoCriticitaFragment
        ...bollettinoVigilanzaFragment
        ...sezioneAllertaMeteoIdroFragment
        ...galleriaFotoFragment
        ...videoFragment
        ...galleriaFlickrFragment
        }      
        field_avvisi_it_alert {
          field_titolo
          field_didascalia{
            processed
          }
          relationships {
            field_immagine {
              relationships {
                field_immagine {
                  localFile {
                    publicURL
                  }
                }
              }
              field_alt
              field_didascalia
            }
          }
        }
        field_sfondo_presentazione {
          relationships {
            field_immagine {
              localFile {
                publicURL
              }
            }
          }
          field_alt
          field_didascalia
        }
        field_sfondo_sezione_notifiche {
          relationships {
            field_immagine {
              localFile {
                publicURL
              }
            }
          }
          field_alt
          field_didascalia
          field_titolo_esteso
        }
        field_sottodominio {
          name
        }
        field_video_carousel {
          field_codice_lingua
          field_video {
            title
            uri
          }
          title
          fields {
            slug
          }
          relationships {
            field_sottodominio{
              name
            }
            field_immagine_dettaglio {
              relationships {
                field_immagine {
                  localFile {
                    publicURL
                  }
                }
              }
            }
          }
        }
      }
      title
      field_titolo_presentazione
      field_titolo_esteso
      field_titolo_sezione_avvisi
      field_titolo_sezione_notifiche
      field_titolo_sezione_video
      field_testo_presentazione
      field_testo_sezione_notifiche
      field_choose_link_testo_presenta 
      field_azione_presentazione 
      field_choose_link_act_presenta  
      field_link_ext_act_presenta {
        title
        uri
      }
      field_link_ext_testo_presenta {
        title
        uri
      }
      field_abstract {
        processed
      }
      field_link_sezione_notifiche {
        title
        uri
      }
    },
  menu: allTaxonomyTermMenuItAlert {
            edges {
              node {
                name
                weight
                drupal_internal__tid
                relationships {
                  field_link_menu {
                    ... on node__page {
                      fields {
                        slug
                      }
                      drupal_internal__nid
                    }
                    ... on node__notizia {
                      fields {
                        slug
                      }
                      drupal_internal__nid
                    }
                    ... on node__mappa {
                      fields {
                        slug
                      }
                      drupal_internal__nid
                  }
                    ... on node__elenco_notizie_comunicati_stampa {
                      fields {
                        slug
                      }
                      drupal_internal__nid
                    }
                  }
                  parent {
                    name
                    drupal_internal__tid
                  }
                }
              }
            }
        },
        menuFooter: allTaxonomyTermMenuFooterItAlert {
          edges {
            node {
              name
              weight
              relationships {
                field_link_menu {
                    ... on node__page {
                        fields {
                          slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__notizia {
                        fields {
                          slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__elenco_notizie_comunicati_stampa {
                        fields {
                            slug
                        }
                        drupal_internal__nid
                    }
                }
              }
              drupal_internal__tid
            }
          }
        },
        socialImg: nodeImmagine(title: {eq: "Placeholder social IT Alert"}){
            relationships {
                image:field_immagine {
                  localFile {
                    publicURL
                  }
                }
            }
        }
}

`;
